<template>
  <div style="min-width: 300px">
      <v-dialog
        ref="dialog"
        v-model="modal"
        :return-value.sync="dates"
        :width="310"
        style="min-width: 300px"
        @keydown.esc="modal = false"
      >
        <template v-slot:activator="{ attrs }">
          <div style="display: flex">
            <v-text-field
              :label="label"
              v-model="manualInput"
              v-bind="attrs"
              placeholder="ДД.ММ.ГГГГ - ДД.ММ.ГГГГ"
              append-icon="mdi-calendar"
              @click:append="modal = true"
              @keydown.enter="applyManualInput"
              @blur="applyManualInput"
            ></v-text-field>
            <v-icon
              v-if="dates.length > 0"
              @click="clearDates"
              style="background-color: transparent"
            >mdi-close</v-icon>
          </div>
        </template>
        <v-date-picker
          v-model="dates"
          range
          scrollable
          :month-format="formatMonth"
          :weekday-format="formatDayOfWeek"
          :first-day-of-week="1"
          :title-date-format="formatArrayDates"
          :header-date-format="formatMonthYear"
        >
          <v-spacer></v-spacer>
          <v-btn
            text
            @click="clearDates"
          > Очистить
          </v-btn>
          <v-btn
            text
            @click="modal = false"
          >
            Отмена
          </v-btn>
          <v-btn
            text
            @click="setDates"
          >
            OK
          </v-btn>
        </v-date-picker>
      </v-dialog>
  </div>
</template>

<script>
import { formatDateShort, formatDayOfWeek, formatMonth, formatMonthYear } from '../../helpers/format'
export default {
  name: 'DatePicker',
  props: {
    value: {
      type: Array,
      default: () => []
    },
    label: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      dates: this.value,
      modal: false,
      manualInput: this.formatDatesForDisplay(this.value)
    }
  },
  methods: {
    clearDates () {
      this.dates = []
      this.manualInput = ''
      this.setDates()
    },
    setDates () {
      this.$refs.dialog.save(this.dates)
      const sorted = [...this.dates].sort((a, b) => new Date(a) - new Date(b))
      this.$emit('input', sorted)
      this.manualInput = this.formatDatesForDisplay(sorted)
    },
    applyManualInput () {
      const text = (this.manualInput || '').trim()
      if (!text) {
        if (this.dates.length > 0) {
          this.clearDates()
        }
        return
      }
      const parsed = this.parseManualInput(text)
      if (parsed) {
        this.dates = parsed
        this.setDates()
      } else {
        // Revert to current valid value
        this.manualInput = this.formatDatesForDisplay(this.dates)
      }
    },
    parseManualInput (text) {
      // Format: DD.MM.YYYY or DD.MM.YYYY - DD.MM.YYYY
      const parts = text.split(/\s*-\s*/)
      if (parts.length < 1 || parts.length > 2) return null

      const results = []
      for (const part of parts) {
        const match = part.trim().match(/^(\d{2})\.(\d{2})\.(\d{4})$/)
        if (!match) return null
        const day = parseInt(match[1], 10)
        const month = parseInt(match[2], 10)
        const year = parseInt(match[3], 10)
        if (month < 1 || month > 12 || day < 1 || day > 31 || year < 1900 || year > 2100) return null
        // Check if the date is actually valid
        const date = new Date(year, month - 1, day)
        if (date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day) return null
        // v-date-picker uses YYYY-MM-DD format
        const isoDate = `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`
        results.push(isoDate)
      }
      return results
    },
    formatDatesForDisplay (dates) {
      if (!dates || dates.length === 0) return ''
      return dates
        .map(el => new Date(el))
        .sort((a, b) => a - b)
        .map(el => formatDateShort(el))
        .join(' - ')
    },
    formatMonth (date) {
      return formatMonth(new Date(date))
    },
    formatDayOfWeek (date) {
      return formatDayOfWeek(new Date(date))
    },
    formatArrayDates (dates) {
      return dates.map(el => new Date(el)).sort((a, b) => a - b).map(el => formatDateShort(el)).join(' - ')
    },
    formatMonthYear (date) {
      return formatMonthYear(new Date(date))
    }
  },
  computed: {
    dateRangeText () {
      return this.formatDatesForDisplay(this.dates)
    }
  },
  watch: {
    value () {
      this.dates = this.value
      this.manualInput = this.formatDatesForDisplay(this.value)
    },
    dates () {
      this.manualInput = this.formatDatesForDisplay(this.dates)
    }
  }
}
</script>

<style scoped lang="sass">
  .v-icon:after
    background-color: transparent
</style>
